import { render } from "./SecondaryButton.vue?vue&type=template&id=693a2e42&scoped=true"
import script from "./SecondaryButton.vue?vue&type=script&lang=js"
export * from "./SecondaryButton.vue?vue&type=script&lang=js"

import "./SecondaryButton.vue?vue&type=style&index=0&id=693a2e42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693a2e42"]])

export default __exports__